export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./imageTextResource.vue?vue&type=template&id=58fa2db6&"


//////////////////
// WEBPACK FOOTER
// ./src/components/resource/imageTextResource.vue?vue&type=template&id=58fa2db6&
// module id = null
// module chunks = 